import { render } from "./PublicHeader.vue?vue&type=template&id=a1b66db4"
import script from "./PublicHeader.vue?vue&type=script&lang=js"
export * from "./PublicHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\laragon\\www\\leader-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__